"use strict";
exports.__esModule = true;
var wrapperConfig = {
    components: [
        {
            name: 'iress-button-group',
            preserveProps: ['options'],
            advancedEventNameMapping: {
                iressButtonGroupChange: 'onChange'
            }
        },
        {
            name: 'iress-filter',
            preserveProps: ['options', 'selected'],
            types: {
                Align: 'PopperAlign'
            }
        },
        {
            name: 'iress-toggle',
            advancedEventNameMapping: {
                iressToggleChange: 'onChange'
            },
            types: {
                Layout: 'ToggleLayout'
            }
        },
        {
            name: 'iress-expander',
            types: {
                Slot: 'ExpanderSlot',
                Mode: 'ExpanderMode'
            }
        },
        {
            name: 'iress-slider',
            preserveProps: ['tickLabels']
        },
        {
            name: 'iress-navbar',
            types: {
                HorizontalAlign: 'NavbarHorizontalAlign',
                Breakpoint: 'Breakpoint',
                Padding: 'PaddingSize',
                Slot: 'NavbarSlot'
            }
        },
        {
            name: 'iress-combobox',
            types: {
                Slot: 'ComboboxSlot',
                Width: 'InputWidth',
                DisplayMode: 'DisplayMode'
            },
            functionProps: ['options'],
            preserveProps: ['options', 'selectedOption'],
            advancedEventNameMapping: {
                iressSelectedChange: 'onChange'
            }
        },
        {
            name: 'iress-hide'
        },
        {
            name: 'iress-skeleton',
            types: {
                Mode: 'SkeletonMode',
                TextVariant: 'TextVariant'
            }
        },
        {
            name: 'iress-overlay-panel',
            types: {
                Slot: 'OverlayPanelSlot'
            }
        },
        {
            name: 'iress-popover',
            types: {
                Slot: 'PopoverSlot',
                Align: 'PopperAlign',
                Type: 'PopoverType'
            },
            advancedEventNameMapping: {
                iressPopoverActivated: 'onActivated',
                iressPopoverDeactivated: 'onDeactivated'
            }
        },
        {
            name: 'iress-menu',
            types: {
                Type: 'MenuType',
                Layout: 'MenuLayout'
            }
        },
        {
            name: 'iress-menu-item',
            types: {
                HeadingLevel: 'HeadingLevel',
                Slot: 'MenuItemSlot'
            }
        },
        {
            name: 'iress-skip-link'
        },
        {
            name: 'iress-progress'
        },
        {
            name: 'iress-toaster',
            types: {
                Padding: 'PaddingSize',
                Position: 'ToasterPosition'
            }
        },
        {
            name: 'iress-table',
            types: {
                ColumnAlign: 'TableColumnAlign',
                Scope: 'TableScope',
                CellFormat: 'TableCellFormat',
                SortOrder: 'TableSortOrder'
            },
            preserveProps: ['rowData']
        },
        {
            name: 'iress-slideout',
            types: {
                Mode: 'SlideoutMode',
                Position: 'SlideoutPosition',
                Padding: 'PaddingSize',
                Size: 'SlideoutSize',
                Slot: 'SlideoutSlot'
            },
            advancedEventNameMapping: {
                iressSlideoutEntered: 'onEntered',
                iressSlideoutExited: 'onExited'
            }
        },
        {
            name: 'iress-theme-editor'
        },
        {
            name: 'iress-tab-container',
            types: {
                Layout: 'TabContainerLayout',
                Slot: 'TabContainerSlot'
            },
            advancedEventNameMapping: {
                iressTabChanged: 'onChange'
            },
            Change: 'iressTabChangedEventDetail'
        },
        {
            name: 'iress-tab-panel'
        },
        {
            name: 'iress-tab-button',
            advancedEventNameMapping: {
                iressTabSelected: 'onClick',
                iressTabKeyPressed: 'onKeyPress'
            }
        },
        {
            name: 'iress-form',
            advancedEventNameMapping: {
                iressFormSubmit: 'onSubmit',
                iressFormInvalid: 'onError'
            },
            types: {
                Slot: 'FormSlot'
            }
        },
        {
            name: 'iress-field',
            types: {
                Slot: 'FieldSlot'
            }
        },
        {
            name: 'iress-input',
            types: {
                Type: 'TextFieldType',
                Width: 'InputWidth',
                InputMode: 'InputMode',
                Slot: 'InputSlot'
            }
        },
        { name: 'iress-checkbox' },
        { name: 'iress-checkbox-mark' },
        {
            name: 'iress-checkbox-group',
            types: {
                Layout: 'CheckboxGroupLayout'
            }
        },
        { name: 'iress-radio' },
        {
            name: 'iress-radio-group',
            types: {
                Layout: 'RadioGroupLayout'
            }
        },
        {
            name: 'iress-button',
            types: {
                Mode: 'ButtonMode',
                Type: 'ButtonType',
                Slot: 'ButtonSlot',
                Fluid: 'Breakpoint'
            }
        },
        {
            name: 'iress-badge',
            types: {
                Mode: 'BadgeMode',
                Slot: 'BadgeSlot'
            }
        },
        {
            name: 'iress-panel',
            types: {
                Padding: 'PaddingSize',
                TextAlign: 'TextAlign',
                Background: 'PanelBackground'
            }
        },
        { name: 'iress-container' },
        {
            name: 'iress-col',
            types: {
                Offset: 'ColOffset',
                Span: 'ColSpan',
                AlignSelf: 'ColAlignSelf'
            }
        },
        {
            name: 'iress-row',
            types: {
                VerticalAlign: 'RowVerticalAlign',
                HorizontalAlign: 'RowHorizontalAlign',
                Gutter: 'RowGutter'
            }
        },
        {
            name: 'iress-validation-message',
            types: {
                Status: 'SystemValidationStatus',
                Slot: 'ValidationMessageSlot'
            }
        },
        { name: 'iress-validation-summary' },
        {
            name: 'iress-alert',
            types: {
                Status: 'SystemValidationStatus',
                HeadingLevel: 'HeadingLevel',
                Slot: 'AlertSlot'
            }
        },
        {
            name: 'iress-icon',
            advancedEventNameMapping: {
                iressIconDidLoad: 'onLoad'
            },
            types: {
                Set: 'IconSet',
                Flip: 'IconFlip',
                Rotation: 'IconRotate',
                Spin: 'IconSpin',
                Size: 'IconSize'
            }
        },
        {
            name: 'iress-inline',
            types: {
                Gutter: 'InlineGutter',
                HorizontalAlign: 'InlineHorizontalAlign',
                VerticalAlign: 'InlineVerticalAlign'
            }
        },
        {
            name: 'iress-text',
            types: {
                Element: 'TextElement',
                Variant: 'TextVariant',
                Align: 'TextAlign'
            }
        },
        {
            name: 'iress-stack',
            types: {
                Gutter: 'StackGutter'
            }
        },
        {
            name: 'iress-theme-switcher',
            advancedEventNameMapping: {
                iressThemeChange: 'onChange'
            },
            types: {
                Slot: 'ThemeSwitcherButtonSlot'
            }
        },
        {
            name: 'iress-placeholder'
        },
        {
            name: 'iress-backdrop',
            advancedEventNameMapping: {
                iressBackdropClick: 'onClick'
            }
        },
        {
            name: 'iress-select',
            docsOnly: true
        },
        {
            name: 'iress-modal',
            types: {
                Padding: 'PaddingSize',
                Size: 'ModalSize',
                Slot: 'ModalSlot'
            },
            advancedEventNameMapping: {
                iressModalEntered: 'onEntered',
                iressModalExited: 'onExited'
            }
        },
        {
            name: 'iress-card',
            types: {
                Padding: 'PaddingSize',
                Slot: 'CardSlot',
                HeadingLevel: 'HeadingLevel'
            },
            mapOnClickToButton: true,
            advancedEventNameMapping: {
                iressCardClick: 'onClick'
            }
        },
        {
            name: 'iress-label'
        },
        {
            name: 'iress-tooltip',
            types: {
                Align: 'PopperAlign'
            }
        },
    ],
    general: {
        webPrefix: 'iress-'
    },
    types: {
        componentTypesSrc: '{{componentsPackagePath}}src/components/{{component}}/{{component}}.types',
        includeTypesFiles: [
            '{{componentsPackagePath}}src/components/toast/toast.types',
            '{{componentsPackagePath}}src/utils/interfaces',
        ]
    }
};
exports["default"] = wrapperConfig;
//# sourceMappingURL=wrapper.config.js.map